import { cn } from "@/lib/utils";
import { useLanguage } from "@/features/calculator/i18n";
import { LanguageToggle } from "@/features/calculator/components/LanguageToggle";

export interface HeaderProps {
  className?: string;
}

export function Header({ className }: HeaderProps) {
  const { t } = useLanguage();

  return (
    <header
      className={cn(
        "bg-gradient-to-b from-bb-blood-red to-bb-black",
        "py-8 px-4 text-center relative",
        "border-b-4 border-bb-gold",
        className
      )}
    >
      {/* Language Toggle */}
      <div className="absolute top-4 right-4">
        <LanguageToggle />
      </div>

      <h1
        className={cn(
          "font-display text-[clamp(2.5rem,8vw,5rem)]",
          "tracking-[0.15em] uppercase",
          "text-bb-bone-white",
          "[text-shadow:3px_3px_0_var(--bb-black)]"
        )}
      >
        {t.title}
      </h1>
      <p
        className={cn(
          "font-condensed text-lg",
          "tracking-[0.3em] uppercase",
          "text-bb-gold mt-2"
        )}
      >
        {t.subtitle}
      </p>
    </header>
  );
}
